import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchComments,
  createComment,
  updateComment,
  deleteComment,
} from "./thunks";
import { Comment } from "@/types";
import { toast } from "react-toastify";

interface PaginatedComments {
  data: Comment[];
  total?: number;
  currentPage?: number;
  perPage?: number;
}

interface CommentsState {
  comments: PaginatedComments;
  loading: boolean;
  error: string | null;
}

const initialState: CommentsState = {
  comments: { data: [] },
  loading: false,
  error: null,
};

const CommentSlice = createSlice({
  name: "comments",
  initialState,
  reducers: {
    clearSuppliers: (state) => {
      state.comments = { data: [] };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchComments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchComments.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const payload = action.payload;

        if (Array.isArray(payload.data)) {
          // Dados não paginados
          state.comments = { data: payload.data };
        } else {
          // Dados paginados
          state.comments = {
            data: payload.data.data,
            total: payload.data.total,
            currentPage: payload.data.current_page,
            perPage: payload.data.per_page,
          };
        }
      })
      .addCase(fetchComments.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      })
      // Create
      .addCase(createComment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createComment.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.comments.data.push(action.payload.data);
        toast.success("Commente cadastrado com sucesso!");
      })
      .addCase(createComment.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Não foi possível cadastrar o commente, tente novamente!");
      })

      // Update
      .addCase(updateComment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateComment.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const index = state.comments.data.findIndex(
          (s) => s.id == action.payload.data.id,
        );
        if (index !== -1) {
          state.comments.data[index] = action.payload.data;
        }
        toast.success("Commente atualizado com sucesso!");
      })
      .addCase(updateComment.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      })

      // Delete
      .addCase(deleteComment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteComment.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.comments.data = state.comments.data.filter(
          (s) => String(s.id) != action.payload.data.id,
        );
        toast.success("Commente excluído com sucesso!");
      })
      .addCase(deleteComment.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      });
  },
});

export default CommentSlice.reducer;
